import { Grid } from "@mui/material";
import Filters from "components/common/Filters";
import FilterDescription from "components/common/Filters/FilterDescription";
import Basictabs from "components/common/Tabs";
import Typography from "components/common/Typography";
import { useTranslate } from "hooks/useTranslate";
import React from "react";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { updateSavedFilter } from "utils/CommonFunctions";
import { setCorpViewSelectedTab } from "../CorpUser.Slice";
import "./CorpView.scss";
import ModalHandler from "./ModalHandler";
import { tabDetails } from "./TabsConfig";

interface Props {
  selectedListFilters: any;
  selectedList?: any;
  label: string;
  view?: string;
  selectedListType?: any;
}

const CorpView = (props: Props) => {
  const { label, selectedListFilters, view = "myList", selectedListType, selectedList } = props;
  const selectedTabs = useAppSelector((state) => state.CorpDashboard.selectedTabs);
  const filterCategories = useAppSelector((state) => state.filters.filterCategories);

  const dispatch = useAppDispatch();
  const selectedFilters: any = useAppSelector((state) => state.filters.filters);

  const translate = useTranslate();

  const getSelectedTab = (val: number, type = view) => {
    dispatch(setCorpViewSelectedTab({ type, val }));
  };

  const updateFilters = () => {
    let parentObject: any = {
      id: selectedListFilters?.id,
      filters: selectedFilters
    };
    if (selectedListType === "dynamic")
      parentObject = {
        ...parentObject,
        name: selectedListFilters?.name,
        description: selectedListFilters?.description,
        isFlagged: "N"
      };
    const props = {
      [selectedListType]: [parentObject]
    };
    updateSavedFilter(dispatch, props);
  };

  return (
    <>
      <Grid className="corp-view-component" display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
        <div>
          <Typography variant={"h4"} showBold className="corp-view-heading" component={"div"}>
            {label}
          </Typography>
          {selectedListType === "bookmarked" && (
            <Typography variant={"label"} component={"div"} color={tokens.Text.General.PrimaryBody}>
              {translate("common.defaultSystemList")}
            </Typography>
          )}
        </div>
        <Filters
          isDefaultButtonsApplicable={view === "dashboard" ? true : selectedListType === "dynamic" ? true : false}
          view={view}
          defaultAppliedFilter={selectedListFilters}
          filters={filterCategories}
          parentPage={
            selectedListType === "consultant"
              ? "consultantListDisplay"
              : view === "myList"
              ? "listDisplay"
              : "dashboardDisplay"
          }
          updateSavedFilter={updateFilters}
        />
      </Grid>
      <FilterDescription />
      {(selectedListType === "static" || selectedListType === "consultant") && selectedList?.description && (
        <div className="corp-view-list-description">
          <Typography variant="label">{selectedList?.description}</Typography>
        </div>
      )}

      <Basictabs
        tabDetails={tabDetails(view, selectedListType, selectedList)}
        alignItems="left"
        labelVariant="body2"
        backgroundColor={tokens.Background.General.Primary}
        selectedTab={getSelectedTab}
        defaultTab={selectedTabs[view]}
      />
      <ModalHandler />
    </>
  );
};
export default React.memo(CorpView);
